import { useContext, useRef } from 'react';
import { Button } from 'semantic-ui-react';
import { store } from '../store';
import { SET_IMAGE } from '../types';

const ImageUploadButton = ({ size }) => {
  const { dispatch } = useContext(store);
  const fileInput = useRef();

  const handleFileChange = () => {
    const { files: filesOb } = fileInput.current;
    if (filesOb.length < 1) return;
    const items = Object.values(filesOb);
    const file = items[0];
    fileInput.current.value = '';
    dispatch({ type: SET_IMAGE, payload: URL.createObjectURL(file) });
  };

  return (
    <>
      <Button
        content="Choose File"
        labelPosition="left"
        icon="file"
        size={size}
        onClick={() => fileInput.current.click()}
      />
      <input
        ref={fileInput}
        type="file"
        hidden
        onChange={handleFileChange}
        accept="image/*"
      />
    </>
  );
};

export default ImageUploadButton;
